import React, { useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../services/pbumku/PbumkuService";

const StatusPrimer = ({kodeStatus}) => {

    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [uraianStatus, setUraianStatus] = useState('')

    useEffect(() => {
        const getStatusDok = async () => {
            const response = await pbumkuService.getStatusPrimerById(kodeStatus)
            setUraianStatus(response.data.uraianStatus)
        }
        getStatusDok()
    }, [pbumkuService, kodeStatus])

    return (
        <>
            {uraianStatus}
        </>
    )
}

export default StatusPrimer